export default __webpack_public_path__ + "static/media/Trash 1.d50a1152.svg";